import React from "react";

function Logo(props) {
  return (
    <>
      <img
        className={`${props.menu ? "logoHeader" : "logoLogin"} `}
        src="/assets/img/logoblanco.png"
      />
    </>
  );
}

export default Logo;
